/* === EMAIL CLASSIFICAZIONE INTELLIGENTE V1 - 2026-08-13 === */
import React, { useEffect, useState, useRef } from "react";
import {
  getInterventoDraftKey,
  pruneExpiredInterventoDrafts,
  readInterventoDraft,
  removeInterventoDraft,
  writeInterventoDraft,
} from "../services/interventoDraftStorage";

import axios from "axios";
import ClienteAutocomplete from "./ClienteAutocomplete";

import GiornateIntervento from "./GiornateIntervento";
import "./InterventoForm.css";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "https://interventi.synology.me:5050";

// === BETALUMINA_FLOTTA_V2C_INTERVENTION_TRANSFER_UI_20260902 ===
const extractFlottaJwtV2C = (value) => {
  if (!value) return null;

  const text = String(value).trim();

  if (text.split(".").length === 3) {
    return text;
  }

  try {
    const parsed = JSON.parse(text);

    for (const key of [
      "token",
      "authToken",
      "jwt",
      "accessToken",
      "access_token",
    ]) {
      const candidate = parsed?.[key];

      if (
        typeof candidate === "string" &&
        candidate.split(".").length === 3
      ) {
        return candidate.trim();
      }
    }
  } catch (_) {
    // non JSON
  }

  return null;
};

const getFlottaAuthHeadersV2C = () => {
  const stores = [
    window.localStorage,
    window.sessionStorage,
  ];

  const preferredKeys = [
    "token",
    "authToken",
    "jwt",
    "accessToken",
    "access_token",
  ];

  for (const store of stores) {
    for (const key of preferredKeys) {
      const token = extractFlottaJwtV2C(
        store.getItem(key)
      );

      if (token) {
        return {
          Authorization: `Bearer ${token}`,
        };
      }
    }

    for (let i = 0; i < store.length; i += 1) {
      const key = store.key(i);
      const token = extractFlottaJwtV2C(
        key ? store.getItem(key) : null
      );

      if (token) {
        return {
          Authorization: `Bearer ${token}`,
        };
      }
    }
  }

  return {};
};

const formatFlottaNumberV2C = (
  value,
  digits = 2
) => {
  if (
    value === null ||
    value === undefined ||
    value === ""
  ) {
    return "—";
  }

  const number = Number(value);

  return Number.isFinite(number)
    ? number.toFixed(digits)
    : "—";
};



const InterventoForm = ({
  cliente,
  setCliente,
  clienteId,
  setClienteId,
  onClienteCreato,
  sitoClientePortaleId,
  setSitoClientePortaleId,
    interventoId,
  indirizzo,
  setIndirizzo,
  telefono,
  setTelefono,
  email,
  setEmail,
  numeroFoglioIntervento,
  setNumeroFoglioIntervento,
  causale,
  setCausale,
  descrizione,
  setDescrizione,
  tipoIntervento,
  setTipoIntervento,
  codiceMateriale,
  setCodiceMateriale,
  descrizioneMateriale,
  setDescrizioneMateriale,
  materialeCatalogoId,
  materialiCatalogo,
  loadingMaterialiCatalogo,
  fetchMaterialiCatalogo,
  handleSelectMaterialeCatalogo,
  quantitaMateriale,
  setQuantitaMateriale,
  prezzoUnitario,
  setPrezzoUnitario,
  totale,
  setTotale,
  materiali,
  materialeDaModificare,
  handleUpdateMateriale,
  handleAddMateriale,
  handleEditMateriale,
  handleDeleteMateriale,
  lavoriEseguiti,
  setLavoriEseguiti,
  tecnico,
  setTecnico,
  data,
  setData,
  oraInizio,
  setOraInizio,
  oraFine,
  setOraFine,
  kmPercorsi,
  setKmPercorsi,
  tempoPercorrenza,
  setTempoPercorrenza,
  trasferta,
  setTrasferta,
  costiTrasfertaDettaglio,
  setCostiTrasfertaDettaglio,
  stato,
  handleStatoChange,
  piva,
  setPiva,
  pagato,
  setPagato,
  metodoPagamento,
  setMetodoPagamento,
  minutiPausa,
  setMinutiPausa,
  pausaInizio,
  isClassificazione = false,
}) => {

  // === BETALUMINA AUTOSAVE BOZZA INTERVENTO V1 R4 ===
  const [bozzaDisponibile, setBozzaDisponibile] = useState(null);
  const [bozzaSalvataAlle, setBozzaSalvataAlle] = useState(null);
  const draftReadyRef = useRef(false);
  const latestDraftRef = useRef(null);
  const baselineDraftRef = useRef(null);

  const draftKey = getInterventoDraftKey({
    interventoId: interventoId,
    numeroFoglioIntervento: numeroFoglioIntervento,
  });

  const creaSnapshotBozza = () => ({
    cliente: cliente ?? "",
    clienteId: clienteId ?? null,
    indirizzo: indirizzo ?? "",
    telefono: telefono ?? "",
    email: email ?? "",
    numeroFoglioIntervento: numeroFoglioIntervento ?? "",
    causale: causale ?? "",
    tipoIntervento:
      tipoIntervento && typeof tipoIntervento === "object"
        ? { ...tipoIntervento }
        : {},
    codiceMateriale: codiceMateriale ?? "",
    descrizioneMateriale: descrizioneMateriale ?? "",
    quantitaMateriale: quantitaMateriale ?? "",
    prezzoUnitario: prezzoUnitario ?? "",
    lavoriEseguiti: lavoriEseguiti ?? "",
    tecnico: tecnico ?? "",
    data: data ?? "",
    oraInizio: oraInizio ?? "",
    oraFine: oraFine ?? "",
    kmPercorsi: kmPercorsi ?? "",
    tempoPercorrenza: tempoPercorrenza ?? "",
    trasferta: trasferta ?? "",
    costiTrasfertaDettaglio: costiTrasfertaDettaglio || {},
    piva: piva ?? "",
    pagato: Boolean(pagato),
    metodoPagamento: metodoPagamento ?? "",
  });

  const snapshotUguali = (a, b) => {
    try {
      return JSON.stringify(a || {}) === JSON.stringify(b || {});
    } catch (_) {
      return false;
    }
  };

  const snapshotHaContenuto = (snapshot) => {
    if (!snapshot || typeof snapshot !== "object") return false;
    const stringFields = [
      "cliente",
      "indirizzo",
      "telefono",
      "email",
      "numeroFoglioIntervento",
      "causale",
      "codiceMateriale",
      "descrizioneMateriale",
      "quantitaMateriale",
      "prezzoUnitario",
      "lavoriEseguiti",
      "tecnico",
      "data",
      "oraInizio",
      "oraFine",
      "kmPercorsi",
      "tempoPercorrenza",
      "trasferta",
      "piva",
      "metodoPagamento"
    ];

    if (stringFields.some((field) => String(snapshot[field] ?? "").trim() !== "")) {
      return true;
    }

    if (Object.values(snapshot.tipoIntervento || {}).some(Boolean)) return true;
    if (snapshot.pagato) return true;
    return false;
  };

  const applicaBozza = (snapshot) => {
    if (!snapshot || typeof snapshot !== "object") return;

    if (typeof setCliente === "function") {
      setCliente(snapshot.cliente ?? "");
    }

    if (typeof setClienteId === "function") {
      setClienteId(snapshot.clienteId ?? null);
    }

    if (typeof setIndirizzo === "function") {
      setIndirizzo(snapshot.indirizzo ?? "");
    }

    if (typeof setTelefono === "function") {
      setTelefono(snapshot.telefono ?? "");
    }

    if (typeof setEmail === "function") {
      setEmail(snapshot.email ?? "");
    }

    if (typeof setNumeroFoglioIntervento === "function") {
      setNumeroFoglioIntervento(
        snapshot.numeroFoglioIntervento ?? ""
      );
    }

    if (typeof setCausale === "function") {
      setCausale(snapshot.causale ?? "");
    }

    if (typeof setTipoIntervento === "function") {
      setTipoIntervento(
        snapshot.tipoIntervento &&
          typeof snapshot.tipoIntervento === "object"
          ? { ...snapshot.tipoIntervento }
          : {}
      );
    }

    if (typeof setCodiceMateriale === "function") {
      setCodiceMateriale(snapshot.codiceMateriale ?? "");
    }

    if (typeof setDescrizioneMateriale === "function") {
      setDescrizioneMateriale(
        snapshot.descrizioneMateriale ?? ""
      );
    }

    if (typeof setQuantitaMateriale === "function") {
      setQuantitaMateriale(
        snapshot.quantitaMateriale ?? ""
      );
    }

    if (typeof setPrezzoUnitario === "function") {
      setPrezzoUnitario(snapshot.prezzoUnitario ?? "");
    }

    if (typeof setLavoriEseguiti === "function") {
      setLavoriEseguiti(snapshot.lavoriEseguiti ?? "");
    }

    if (typeof setTecnico === "function") {
      setTecnico(snapshot.tecnico ?? "");
    }

    if (typeof setData === "function") {
      setData(snapshot.data ?? "");
    }

    if (typeof setOraInizio === "function") {
      setOraInizio(snapshot.oraInizio ?? "");
    }

    if (typeof setOraFine === "function") {
      setOraFine(snapshot.oraFine ?? "");
    }

    if (typeof setKmPercorsi === "function") {
      setKmPercorsi(snapshot.kmPercorsi ?? "");
    }

    if (typeof setTempoPercorrenza === "function") {
      setTempoPercorrenza(
        snapshot.tempoPercorrenza ?? ""
      );
    }

    if (typeof setTrasferta === "function") {
      setTrasferta(snapshot.trasferta ?? "");
    }
    if (typeof setCostiTrasfertaDettaglio === "function") {
      setCostiTrasfertaDettaglio({ ...(costiTrasfertaDettaglio || {}), ...(snapshot.costiTrasfertaDettaglio || {}) });
    }

    if (typeof setPiva === "function") {
      setPiva(snapshot.piva ?? "");
    }

    if (typeof setPagato === "function") {
      setPagato(Boolean(snapshot.pagato));
    }

    if (typeof setMetodoPagamento === "function") {
      setMetodoPagamento(
        snapshot.metodoPagamento ?? ""
      );
    }
  };

  const ripristinaBozza = () => {
    if (!bozzaDisponibile?.data) return;
    applicaBozza(bozzaDisponibile.data);
    draftReadyRef.current = true;
    latestDraftRef.current = bozzaDisponibile.data;
    setBozzaSalvataAlle(Number(bozzaDisponibile.savedAt) || Date.now());
    setBozzaDisponibile(null);
  };

  const scartaBozza = () => {
    removeInterventoDraft(draftKey);
    baselineDraftRef.current = creaSnapshotBozza();
    draftReadyRef.current = true;
    setBozzaDisponibile(null);
    setBozzaSalvataAlle(null);
  };

  useEffect(() => {
    pruneExpiredInterventoDrafts();
    draftReadyRef.current = false;
    latestDraftRef.current = null;
    baselineDraftRef.current = null;
    setBozzaDisponibile(null);
    setBozzaSalvataAlle(null);

    const timer = window.setTimeout(() => {
      const current = creaSnapshotBozza();
      const draft = readInterventoDraft(draftKey);

      baselineDraftRef.current = current;
      latestDraftRef.current = current;

      if (!draft) {
        draftReadyRef.current = true;
        return;
      }

      if (snapshotUguali(draft.data, current)) {
        removeInterventoDraft(draftKey);
        draftReadyRef.current = true;
        return;
      }

      setBozzaDisponibile(draft);
    }, 350);

    return () => window.clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [draftKey]);

  useEffect(() => {
    const snapshot = creaSnapshotBozza();
    latestDraftRef.current = snapshot;

    if (
      !draftReadyRef.current ||
      bozzaDisponibile ||
      !snapshotHaContenuto(snapshot) ||
      snapshotUguali(snapshot, baselineDraftRef.current)
    ) {
      return undefined;
    }

    const timer = window.setTimeout(() => {
      if (writeInterventoDraft(draftKey, latestDraftRef.current)) {
        setBozzaSalvataAlle(Date.now());
      }
    }, 700);

    return () => window.clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    draftKey,
    bozzaDisponibile,
    cliente,
    clienteId,
    indirizzo,
    telefono,
    email,
    numeroFoglioIntervento,
    causale,
    tipoIntervento,
    codiceMateriale,
    descrizioneMateriale,
    quantitaMateriale,
    prezzoUnitario,
    lavoriEseguiti,
    tecnico,
    data,
    oraInizio,
    oraFine,
    kmPercorsi,
    tempoPercorrenza,
    trasferta,
    costiTrasfertaDettaglio,
    piva,
    pagato,
    metodoPagamento
  ]);

  useEffect(() => {
    const flushDraft = () => {
      if (
        !draftReadyRef.current ||
        !latestDraftRef.current ||
        !snapshotHaContenuto(latestDraftRef.current) ||
        snapshotUguali(latestDraftRef.current, baselineDraftRef.current)
      ) {
        return;
      }

      writeInterventoDraft(draftKey, latestDraftRef.current);
    };

    const handleVisibility = () => {
      if (document.visibilityState === "hidden") flushDraft();
    };

    window.addEventListener("pagehide", flushDraft);
    document.addEventListener("visibilitychange", handleVisibility);

    return () => {
      window.removeEventListener("pagehide", flushDraft);
      document.removeEventListener("visibilitychange", handleVisibility);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [draftKey]);
  // === END BETALUMINA AUTOSAVE BOZZA INTERVENTO V1 R4 ===

  // --- START Pausa: state + logica V2 ---
  const [isPaused, setIsPaused] = useState(false);
  const [pausaChiusaSec, setPausaChiusaSec] = useState(0);
  const [pausaStartedAt, setPausaStartedAt] = useState(null);
  const [pausaNow, setPausaNow] = useState(Date.now());
  const [pausaBusy, setPausaBusy] = useState(false);
  const [lavoroBusy, setLavoroBusy] = useState(false);
  const [lavoroAttivo, setLavoroAttivo] = useState(false);

  // === V2-C riepilogo Flotta automatico intervento ===
  const [
    trasfertaAutoV2C,
    setTrasfertaAutoV2C,
  ] = useState(null);

  const [
    trasfertaAutoLoadingV2C,
    setTrasfertaAutoLoadingV2C,
  ] = useState(false);

  const [
    trasfertaAutoErrorV2C,
    setTrasfertaAutoErrorV2C,
  ] = useState("");

  useEffect(() => {
    if (!interventoId || isClassificazione) {
      setTrasfertaAutoV2C(null);
      setTrasfertaAutoErrorV2C("");
      return undefined;
    }

    let active = true;

    const loadTrasfertaAutoV2C = async () => {
      setTrasfertaAutoLoadingV2C(true);
      setTrasfertaAutoErrorV2C("");

      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/flotta/costi-intervento/${interventoId}`,
          {
            params: {
              vehicle: "fiorino",
            },
            headers: getFlottaAuthHeadersV2C(),
          }
        );

        if (active) {
          setTrasfertaAutoV2C(
            response.data || null
          );
        }
      } catch (error) {
        if (active) {
          setTrasfertaAutoV2C(null);

          setTrasfertaAutoErrorV2C(
            error.response?.status === 403
              ? "Sessione Flotta non valida"
              : error.response?.data?.error ||
                "Riepilogo Flotta non disponibile"
          );
        }
      } finally {
        if (active) {
          setTrasfertaAutoLoadingV2C(false);
        }
      }
    };

    loadTrasfertaAutoV2C();

    return () => {
      active = false;
    };
  }, [interventoId, isClassificazione]);

  // Stato catalogo materiali: indipendente dalla pausa.
  const [ricercaMaterialeCatalogo, setRicercaMaterialeCatalogo] =
    useState("");
  const [catalogoMaterialiAperto, setCatalogoMaterialiAperto] =
    useState(false);


  // Compatibilità con i vecchi campi dell'intervento.
  const [pausaTotaleMin, setPausaTotaleMin] = useState(Number(minutiPausa) || 0);

  useEffect(() => {
    if (Number.isFinite(Number(minutiPausa))) {
      setPausaTotaleMin(Number(minutiPausa));
    }
  }, [minutiPausa]);

  useEffect(() => {
    if (
      typeof fetchMaterialiCatalogo === "function" &&
      (!Array.isArray(materialiCatalogo) || materialiCatalogo.length === 0)
    ) {
      fetchMaterialiCatalogo();
    }
    // Caricamento iniziale del catalogo all'apertura del form.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const quantita = Number.parseFloat(quantitaMateriale);
    const prezzo = Number.parseFloat(prezzoUnitario);

    if (
      Number.isFinite(quantita) &&
      quantita > 0 &&
      Number.isFinite(prezzo) &&
      prezzo >= 0
    ) {
      setTotale((quantita * prezzo).toFixed(2));
    } else {
      setTotale("");
    }
  }, [quantitaMateriale, prezzoUnitario, setTotale]);

  const applyPausaStatus = (payload) => {
    const active = Boolean(payload?.attiva);
    const closedSec = Math.max(
      0,
      Number(payload?.pausa_secondi_chiusi) || 0
    );

    setIsPaused(active);
    setPausaChiusaSec(closedSec);
    setPausaStartedAt(payload?.pausa_inizio || null);
    setPausaNow(Date.now());

    if (typeof setMinutiPausa === "function") {
      setMinutiPausa(
        Math.max(0, Number(payload?.totale_minuti_corrente) || 0)
      );
    }
  };

  const loadPausaStatus = async () => {
    if (!interventoId) {
      setIsPaused(false);
      setPausaChiusaSec(0);
      setPausaStartedAt(null);
      return;
    }

    try {
      const token = localStorage.getItem("token");

      const res = await axios.get(
        `${API_BASE_URL}/interventi/${interventoId}/pausa-operativa`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      );
      applyPausaStatus(res.data);
    } catch (err) {
      console.error("Errore caricamento pausa operativa:", err);
    }
  };

  useEffect(() => {
    loadPausaStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [interventoId]);

  useEffect(() => {
    if (!isPaused) return undefined;

    const timer = setInterval(() => {
      setPausaNow(Date.now());
    }, 1000);

    return () => clearInterval(timer);
  }, [isPaused]);

  const pausaLiveSec = (() => {
    if (!isPaused || !pausaStartedAt) return 0;

    const start = new Date(
      String(pausaStartedAt).replace(" ", "T")
    ).getTime();

    if (!Number.isFinite(start)) return 0;

    return Math.max(0, Math.floor((pausaNow - start) / 1000));
  })();

  const displayedPausaSec = pausaChiusaSec + pausaLiveSec;
  const displayedPausaMin = Math.round(displayedPausaSec / 60);

  const displayedPausaClock = (() => {
    const sec = Math.max(0, displayedPausaSec);
    const hh = String(Math.floor(sec / 3600)).padStart(2, "0");
    const mm = String(Math.floor((sec % 3600) / 60)).padStart(2, "0");
    const ss = String(sec % 60).padStart(2, "0");
    return `${hh}:${mm}:${ss}`;
  })();

  const ricercaCatalogoNormalizzata =
    ricercaMaterialeCatalogo.trim().toLowerCase();

  const materialiCatalogoFiltrati = (
    Array.isArray(materialiCatalogo)
      ? materialiCatalogo
      : []
  ).filter((materiale) => {
    if (!ricercaCatalogoNormalizzata) {
      return true;
    }

    const codice = String(
      materiale.codiceMateriale || ""
    ).toLowerCase();

    const descrizione = String(
      materiale.descrizioneMateriale || ""
    ).toLowerCase();

    return (
      codice.includes(ricercaCatalogoNormalizzata) ||
      descrizione.includes(ricercaCatalogoNormalizzata)
    );
  });

  const aggiornaPausaManuale = (valore) => {
    const minuti = Math.max(0, parseInt(valore || "0", 10) || 0);
    setPausaTotaleMin(minuti);

    if (typeof setMinutiPausa === "function") {
      setMinutiPausa(minuti);
    }
  };

  const cambiaPausaOperativa = async (attiva) => {
    if (!interventoId || pausaBusy) return false;
    if (Boolean(attiva) === Boolean(isPaused)) return true;

    setPausaBusy(true);

    try {
      const action = attiva ? "start" : "stop";
      const token = localStorage.getItem("token");

      if (!token) {
        throw new Error("Token di autenticazione non trovato");
      }

      const res = await axios.post(
        `${API_BASE_URL}/interventi/${interventoId}/pausa-operativa/${action}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      );

      applyPausaStatus(res.data);

      window.dispatchEvent(
        new CustomEvent("betalumina:giornate-refresh", {
          detail: { interventoId: Number(interventoId) },
        })
      );

      return true;
    } catch (err) {
      console.error("Errore cambio pausa operativa:", err);
      alert(
        err?.response?.data?.message ||
        "Impossibile aggiornare la pausa. Riprova."
      );
      return false;
    } finally {
      setPausaBusy(false);
    }
  };

  const handleTogglePausa = async () => {
    await cambiaPausaOperativa(!isPaused);
  };

  // ===== AVVIO/FINE LAVORO AUTOMATICI V10 =====
  useEffect(() => {
    if (!String(tecnico || "").trim() && typeof setTecnico === "function") {
      setTecnico("Carrino");
    }
  }, [tecnico, setTecnico]);

  const loadLavoroOperativo = async () => {
    if (!interventoId) {
      setLavoroAttivo(false);
      return;
    }

    try {
      const token = localStorage.getItem("token");

      const res = await axios.get(
        `${API_BASE_URL}/interventi/${interventoId}/lavoro-operativo`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      );

      const sessione = res.data?.sessione || null;
      const active = Boolean(res.data?.attiva);

      setLavoroAttivo(active);

      if (sessione?.tecnico && typeof setTecnico === "function") {
        setTecnico(sessione.tecnico);
      }

      if (
        active &&
        sessione?.ora_inizio &&
        !String(oraInizio || "").trim() &&
        typeof setOraInizio === "function"
      ) {
        setOraInizio(sessione.ora_inizio);
      }
    } catch (err) {
      console.error("Errore stato lavoro operativo:", err);
    }
  };

  useEffect(() => {
    loadLavoroOperativo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [interventoId]);

  const avviaLavoroOperativo = async () => {
    if (!interventoId || lavoroBusy) return false;

    setLavoroBusy(true);

    try {
      const token = localStorage.getItem("token");
      const tecnicoEffettivo =
        String(tecnico || "").trim() || "Carrino";

      const res = await axios.post(
        `${API_BASE_URL}/interventi/${interventoId}/lavoro-operativo/start`,
        {
          tecnico: tecnicoEffettivo,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      );

      if (typeof setTecnico === "function") {
        setTecnico(res.data?.tecnico || "Carrino");
      }

      if (
        !String(data || "").trim() &&
        res.data?.data &&
        typeof setData === "function"
      ) {
        setData(res.data.data);
      }

      if (
        !String(oraInizio || "").trim() &&
        res.data?.ora_inizio &&
        typeof setOraInizio === "function"
      ) {
        setOraInizio(res.data.ora_inizio);
      }

      if (typeof setOraFine === "function") {
        setOraFine("");
      }

      setLavoroAttivo(true);

      window.dispatchEvent(
        new CustomEvent("betalumina:giornate-refresh", {
          detail: {
            interventoId: Number(interventoId),
          },
        })
      );

      return true;
    } catch (err) {
      console.error("Errore avvio lavoro:", err);

      alert(
        err?.response?.data?.message ||
        "Impossibile registrare automaticamente l'ora di inizio."
      );

      return false;
    } finally {
      setLavoroBusy(false);
    }
  };

  const fineLavoroOperativo = async () => {
    if (!interventoId || lavoroBusy || !lavoroAttivo) {
      return false;
    }

    setLavoroBusy(true);

    try {
      if (isPaused) {
        const stopped = await cambiaPausaOperativa(false);
        if (!stopped) return false;
      }

      const token = localStorage.getItem("token");

      const res = await axios.post(
        `${API_BASE_URL}/interventi/${interventoId}/lavoro-operativo/stop`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      );

      if (typeof setTecnico === "function") {
        setTecnico(res.data?.tecnico || "Carrino");
      }

      if (
        res.data?.ora_fine &&
        typeof setOraFine === "function"
      ) {
        setOraFine(res.data.ora_fine);
      }

      setLavoroAttivo(false);

      window.dispatchEvent(
        new CustomEvent("betalumina:giornate-refresh", {
          detail: {
            interventoId: Number(interventoId),
          },
        })
      );

      return true;
    } catch (err) {
      console.error("Errore fine lavoro:", err);

      alert(
        err?.response?.data?.message ||
        "Impossibile registrare automaticamente l'ora di fine."
      );

      return false;
    } finally {
      setLavoroBusy(false);
    }
  };

  const handleStatoButtonClick = async (value) => {
    if (lavoroBusy) return;

    if (value === "In corso") {
      const started = await avviaLavoroOperativo();
      if (!started) return;

      if (typeof handleStatoChange === "function") {
        handleStatoChange("In corso");
      }

      return;
    }

    if (value === "Completato") {
      if (lavoroAttivo) {
        const ended = await fineLavoroOperativo();
        if (!ended) return;
      } else if (isPaused) {
        const stopped = await cambiaPausaOperativa(false);
        if (!stopped) return;
      }

      if (typeof handleStatoChange === "function") {
        handleStatoChange("Completato");
      }

      return;
    }

    if (value === "Da fare" && lavoroAttivo) {
      alert('Termina prima la giornata con "Fine lavoro".');
      return;
    }

    if (isPaused) {
      const stopped = await cambiaPausaOperativa(false);
      if (!stopped) return;
    }

    if (typeof handleStatoChange === "function") {
      handleStatoChange(value);
    }
  };
  // --- END Pausa ---


  // === BETALUMINA FIRMA CLIENTE UI REALE V2 - 2026-08-26 ===
  const firmaClienteCanvasRefV2 = React.useRef(null);
  const firmaClienteDrawingRefV2 = React.useRef(false);
  const firmaClienteLastRefV2 = React.useRef({ x: 0, y: 0 });
  const firmaClienteFullscreenRefV2 = React.useRef(false);

  const [firmaClienteOpenV2, setFirmaClienteOpenV2] = React.useState(false);
  const [firmaClienteNomeV2, setFirmaClienteNomeV2] = React.useState("");
  const [firmaClientePresenteV2, setFirmaClientePresenteV2] = React.useState(false);
  const [firmaClienteDataUrlV2, setFirmaClienteDataUrlV2] = React.useState(null);
  const [firmaClienteHasInkV2, setFirmaClienteHasInkV2] = React.useState(false);
  const [firmaClienteSavingV2, setFirmaClienteSavingV2] = React.useState(false);
  const [firmaClienteMsgV2, setFirmaClienteMsgV2] = React.useState("");

  const firmaClienteApiV2 = () =>
    interventoId
      ? `${API_BASE_URL}/interventi/${interventoId}/firma-cliente`
      : null;

  const firmaClienteHeadersV2 = (json = false) => {
    const token = localStorage.getItem("token");
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    if (json) headers["Content-Type"] = "application/json";
    return headers;
  };

  const loadFirmaClienteV2 = async () => {
    if (!interventoId) {
      setFirmaClientePresenteV2(false);
      setFirmaClienteNomeV2("");
      setFirmaClienteDataUrlV2(null);
      return;
    }

    try {
      const res = await fetch(firmaClienteApiV2(), {
        headers: firmaClienteHeadersV2(false),
      });

      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
      }

      const data = await res.json();
      setFirmaClientePresenteV2(!!data.hasSignature);
      setFirmaClienteNomeV2(String(data.nome || ""));
      setFirmaClienteDataUrlV2(data.signature || null);
      setFirmaClienteHasInkV2(!!data.hasSignature);
      setFirmaClienteMsgV2("");
    } catch (err) {
      console.error("Firma cliente - lettura:", err);
      setFirmaClienteMsgV2("Impossibile leggere la firma salvata");
    }
  };

  React.useEffect(() => {
    loadFirmaClienteV2();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [interventoId]);

  const prepareFirmaClienteCanvasV2 = (dataUrl = null) => {
    const canvas = firmaClienteCanvasRefV2.current;
    if (!canvas) return;

    canvas.width = 1000;
    canvas.height = 300;

    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    if (!dataUrl) {
      setFirmaClienteHasInkV2(false);
      return;
    }

    const img = new Image();
    img.onload = () => {
      const scale = Math.min(canvas.width / img.width, canvas.height / img.height);
      const w = img.width * scale;
      const h = img.height * scale;
      ctx.drawImage(
        img,
        (canvas.width - w) / 2,
        (canvas.height - h) / 2,
        w,
        h
      );
      setFirmaClienteHasInkV2(true);
    };
    img.src = dataUrl;
  };

  React.useEffect(() => {
    if (!firmaClienteOpenV2) return;
    const timer = window.setTimeout(() => {
      prepareFirmaClienteCanvasV2(firmaClienteDataUrlV2);
    }, 0);
    return () => window.clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firmaClienteOpenV2, firmaClienteDataUrlV2]);

  const enterFirmaClienteLandscapeV2 = async () => {
    setFirmaClienteMsgV2("");
    setFirmaClienteOpenV2(true);

    try {
      if (!document.fullscreenElement && document.documentElement?.requestFullscreen) {
        await document.documentElement.requestFullscreen();
        firmaClienteFullscreenRefV2.current = true;
      }
    } catch (_) {
      firmaClienteFullscreenRefV2.current = false;
    }

    try {
      if (window.screen?.orientation?.lock) {
        await window.screen.orientation.lock("landscape");
      }
    } catch (_) {
      // Su browser senza lock automatico la schermata firma resta comunque dedicata.
    }
  };

  const exitFirmaClienteLandscapeV2 = async () => {
    try {
      if (window.screen?.orientation?.unlock) {
        window.screen.orientation.unlock();
      }
    } catch (_) {}

    try {
      if (
        firmaClienteFullscreenRefV2.current &&
        document.fullscreenElement &&
        document.exitFullscreen
      ) {
        await document.exitFullscreen();
      }
    } catch (_) {}

    firmaClienteFullscreenRefV2.current = false;
    setFirmaClienteOpenV2(false);
  };

  const firmaClientePointV2 = (event) => {
    const canvas = firmaClienteCanvasRefV2.current;
    const rect = canvas.getBoundingClientRect();

    return {
      x: (event.clientX - rect.left) * (canvas.width / Math.max(rect.width, 1)),
      y: (event.clientY - rect.top) * (canvas.height / Math.max(rect.height, 1)),
    };
  };

  const firmaClientePointerDownV2 = (event) => {
    const canvas = firmaClienteCanvasRefV2.current;
    if (!canvas) return;

    event.preventDefault();

    try {
      event.currentTarget.setPointerCapture(event.pointerId);
    } catch (_) {}

    const point = firmaClientePointV2(event);
    firmaClienteDrawingRefV2.current = true;
    firmaClienteLastRefV2.current = point;

    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#111827";
    ctx.beginPath();
    ctx.arc(point.x, point.y, 2.5, 0, Math.PI * 2);
    ctx.fill();

    setFirmaClienteHasInkV2(true);
  };

  const firmaClientePointerMoveV2 = (event) => {
    if (!firmaClienteDrawingRefV2.current) return;

    const canvas = firmaClienteCanvasRefV2.current;
    if (!canvas) return;

    event.preventDefault();

    const point = firmaClientePointV2(event);
    const previous = firmaClienteLastRefV2.current;
    const ctx = canvas.getContext("2d");

    ctx.strokeStyle = "#111827";
    ctx.lineWidth = 4;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.beginPath();
    ctx.moveTo(previous.x, previous.y);
    ctx.lineTo(point.x, point.y);
    ctx.stroke();

    firmaClienteLastRefV2.current = point;
    setFirmaClienteHasInkV2(true);
  };

  const firmaClientePointerUpV2 = (event) => {
    firmaClienteDrawingRefV2.current = false;
    try {
      event.currentTarget.releasePointerCapture(event.pointerId);
    } catch (_) {}
  };

  const clearFirmaClienteV2 = () => {
    setFirmaClienteDataUrlV2(null);
    prepareFirmaClienteCanvasV2(null);
    setFirmaClienteMsgV2("");
  };

  const saveFirmaClienteV2 = async () => {
    const nome = firmaClienteNomeV2.trim();
    const canvas = firmaClienteCanvasRefV2.current;

    if (!nome) {
      setFirmaClienteMsgV2("Inserisci nome e cognome del firmatario");
      return;
    }

    if (!canvas || !firmaClienteHasInkV2) {
      setFirmaClienteMsgV2("Firma nel riquadro con il dito");
      return;
    }

    let signature = canvas.toDataURL("image/jpeg", 0.78);
    if (signature.length > 85000) signature = canvas.toDataURL("image/jpeg", 0.62);
    if (signature.length > 92000) signature = canvas.toDataURL("image/jpeg", 0.48);

    if (signature.length > 95000) {
      setFirmaClienteMsgV2("Firma troppo complessa: cancella e riprova");
      return;
    }

    setFirmaClienteSavingV2(true);
    setFirmaClienteMsgV2("Salvataggio...");

    try {
      const res = await fetch(firmaClienteApiV2(), {
        method: "POST",
        headers: firmaClienteHeadersV2(true),
        body: JSON.stringify({
          nome,
          signature,
        }),
      });

      if (!res.ok) {
        const text = await res.text();
        throw new Error(`${res.status} - ${text}`);
      }

      const data = await res.json();

      setFirmaClienteNomeV2(String(data.nome || nome));
      setFirmaClienteDataUrlV2(signature);
      setFirmaClientePresenteV2(true);
      setFirmaClienteHasInkV2(true);
      setFirmaClienteMsgV2("Firma salvata");

      await exitFirmaClienteLandscapeV2();
    } catch (err) {
      console.error("Firma cliente - salvataggio:", err);
      setFirmaClienteMsgV2("Errore nel salvataggio della firma");
    } finally {
      setFirmaClienteSavingV2(false);
    }
  };

  const removeFirmaClienteV2 = async () => {
    if (!interventoId) return;
    if (!window.confirm("Rimuovere la firma cliente salvata?")) return;

    setFirmaClienteSavingV2(true);

    try {
      const res = await fetch(firmaClienteApiV2(), {
        method: "DELETE",
        headers: firmaClienteHeadersV2(false),
      });

      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
      }

      setFirmaClientePresenteV2(false);
      setFirmaClienteNomeV2("");
      setFirmaClienteDataUrlV2(null);
      setFirmaClienteHasInkV2(false);
      setFirmaClienteMsgV2("Firma rimossa");
    } catch (err) {
      console.error("Firma cliente - rimozione:", err);
      setFirmaClienteMsgV2("Errore nella rimozione della firma");
    } finally {
      setFirmaClienteSavingV2(false);
    }
  };
  // === END BETALUMINA FIRMA CLIENTE UI REALE V2 ===

    // === BETALUMINA INTERVENTI SITE-AWARE V0.4.1 ===
  const [sitiClientePortale, setSitiClientePortale] = React.useState([]);

  React.useEffect(() => {
    let cancelled = false;
    if (!clienteId) { setSitiClientePortale([]); setSitoClientePortaleId(""); return () => { cancelled = true; }; }
    const token = localStorage.getItem("token");
    fetch(`${API_BASE_URL}/api/portal-admin/clienti/${clienteId}/siti`, { headers: token ? { Authorization: `Bearer ${token}` } : {} })
      .then((r) => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
      .then((rows) => { if (!cancelled) setSitiClientePortale(Array.isArray(rows) ? rows.filter((x) => Number(x?.attivo) === 1) : []); })
      .catch((err) => { if (!cancelled) { console.warn("[interventi-v041] siti:", err); setSitiClientePortale([]); setSitoClientePortaleId(""); } });
    return () => { cancelled = true; };
  }, [clienteId]);

  React.useEffect(() => {
    const norm = (v) => String(v || "").trim().toLowerCase().replace(/\s+/g, " ");
    const match = sitiClientePortale.find((x) => norm(x?.indirizzo) === norm(indirizzo));
    setSitoClientePortaleId(match ? String(match.id) : "");
  }, [sitiClientePortale, indirizzo]);

return (
    <div className="intervento-form-modern">

      {/* BETALUMINA AUTOSAVE BOZZA INTERVENTO V1 R4 - UI */}
      {bozzaDisponibile && (
        <div className="intervento-draft-recovery" role="status">
          <div>
            <strong>Bozza non salvata trovata</strong>
            <span>
              È stata recuperata una compilazione precedente di questo
              bollettino. Il database non è stato modificato.
            </span>
          </div>
          <div className="intervento-draft-actions">
            <button type="button" className="intervento-draft-restore" onClick={ripristinaBozza}>
              Ripristina bozza
            </button>
            <button type="button" className="intervento-draft-discard" onClick={scartaBozza}>
              Scarta
            </button>
          </div>
        </div>
      )}

      {!bozzaDisponibile && bozzaSalvataAlle && (
        <div className="intervento-draft-saved" aria-live="polite">
          Bozza protetta sul dispositivo ·{" "}
          {new Date(bozzaSalvataAlle).toLocaleTimeString("it-IT", {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </div>
      )}

      {isClassificazione && (
        <div
          className="modalita-classificazione-banner"
          style={{
            marginBottom: 18,
            padding: 14,
            border: "1px solid #86c79f",
            borderRadius: 10,
            background: "#eef9f2",
            color: "#155d32",
            fontWeight: 600,
          }}
        >
          Verifica le proposte ricavate dall’email: Cliente, Indirizzo, Causale e Richiesta / segnalazione. “Lavori eseguiti” resterà vuoto fino allo svolgimento reale dell’intervento.</div>
      )}

      {/* Flag rosso semplice per FATTURATO (solo se stato specifico) */}
      {stato === "CHIUSO fatturato" && (
        <div className="stato-flag">
          <span className="flag-fatturato">FATTURATO!</span>
        </div>
      )}

      <section className="intervento-card intervento-card--cliente">
          <div className="intervento-card-header">
            <div>
              <h4>Cliente</h4>
              <p>Dati anagrafici e contatti dell'intervento</p>
            </div>
          </div>

          <div className="intervento-grid intervento-grid--cliente">
            <div className="intervento-field intervento-field--full">
              <label>Cliente</label>
              <ClienteAutocomplete
                cliente={cliente}
                setCliente={setCliente}
                clienteId={clienteId}
                setClienteId={setClienteId}
                onClienteCreato={onClienteCreato}
                indirizzo={indirizzo}
                setIndirizzo={setIndirizzo}
                telefono={telefono}
                setTelefono={setTelefono}
                email={email}
                setEmail={setEmail}
              />

              {/* BETALUMINA INTERVENTI SITE-AWARE V0.4.1 */}
              {clienteId && sitiClientePortale.length > 0 && (
                <div className="form-group">
                  <label htmlFor="sitoClientePortaleId">Sito / impianto</label>
                  <select id="sitoClientePortaleId" name="sito_id" value={sitoClientePortaleId}
                    onChange={(e) => {
                      const value=e.target.value; setSitoClientePortaleId(value);
                      const selected=sitiClientePortale.find((x)=>String(x.id)===String(value));
                      if (selected?.indirizzo) setIndirizzo(selected.indirizzo);
                    }}>
                    <option value="">Seleziona sito / impianto</option>
                    {sitiClientePortale.map((sito)=>(<option key={sito.id} value={sito.id}>{sito.nome} - {sito.indirizzo}</option>))}
                  </select>
                  <input type="hidden" name="cliente_id" value={clienteId || ""} />
                </div>
              )}

            </div>

            <div className="intervento-field">
              <label>Indirizzo</label>
              <input
                type="text"
                value={indirizzo ?? ""}
                onChange={(e) => setIndirizzo(e.target.value || "")}
              />
            </div>

            <div className="intervento-field">
              <label>Telefono</label>
              <input
                type="text"
                value={telefono ?? ""}
                onChange={(e) => setTelefono(e.target.value || "")}
              />
            </div>

            <div className="intervento-field intervento-field--full">
              <label>Email</label>
              <input
                type="email"
                value={email ?? ""}
                onChange={(e) => setEmail(e.target.value || "")}
              />
            </div>
          </div>
        </section>

        <section className="intervento-card intervento-card--dettagli">
          <div className="intervento-card-header">
            <div>
              <h4>Intervento</h4>
              <p>Identificazione, causale e tipologia</p>
            </div>
          </div>

          <div className="intervento-grid">
            <div className="intervento-field">
              <label>Numero Foglio Intervento</label>
              <input
                type="text"
                value={numeroFoglioIntervento ?? ""}
                onChange={(e) => setNumeroFoglioIntervento(e.target.value || "")}
                placeholder="Es. FI-001"
              />
            </div>

            

            

            <div className="intervento-field intervento-field--full">
              <label>Tipo intervento</label>
              <div className="checkbox-group">
                {["garanzia", "manutenzione", "pagamento", "installazione", "ultimare"].map((tipo) => (
                  <label key={tipo}>
                    <input
                      type="checkbox"
                      name={tipo}
                      checked={!!(tipoIntervento?.[tipo])}
                      onChange={(e) =>
                        setTipoIntervento((prev) => ({
                          ...prev,
                          [e.target.name]: e.target.checked,
                        }))
                      }
                    />
                    {tipo.charAt(0).toUpperCase() + tipo.slice(1)}
                  </label>
                ))}
              </div>
            </div>

<div className="intervento-field intervento-field--full intervento-field--causale">
              <label>Causale</label>
              <textarea
                value={causale ?? ""}
                onChange={(e) => setCausale(e.target.value || "")}
                rows={3}
                placeholder="Descrivi il motivo dell'intervento"
              />
            </div>
<div className="intervento-field intervento-field--full richiesta-segnalazione-section">
  <label>Richiesta / segnalazione</label>
  <textarea
    value={descrizione ?? ""}
    onChange={(e) => setDescrizione(e.target.value || "")}
    rows={4}
    placeholder="Motivo della chiamata / problema segnalato dal cliente"
  />
  <small>
    Motivo della richiesta ricevuta. Non è il consuntivo dei lavori eseguiti.
  </small>
</div>

<div className="intervento-field intervento-field--full">
              <label>{isClassificazione ? "Lavori eseguiti (dopo l’intervento)" : "Lavori eseguiti"}</label>
              <textarea
                disabled={isClassificazione}
                value={lavoriEseguiti ?? ""}
                onChange={(e) => setLavoriEseguiti(e.target.value || "")}
                rows={4}
                placeholder="Descrivi le attività svolte"
              />
              {isClassificazione && (
                <small className="lavori-eseguiti-classificazione-info">
                  Questo campo resta intenzionalmente vuoto fino all’esecuzione reale dell’intervento.
                </small>
              )}
            </div>
          </div>
        </section>

        <div className="modal-section materiale-intervento-section">
        <label>Materiali utilizzati:</label>

        <div className="materiale-catalogo-box">
          <div className="materiale-catalogo-header">
            <div>
              <label>Catalogo materiali</label>
              <small>
                {materialiCatalogoFiltrati.length} risultati su{" "}
                {Array.isArray(materialiCatalogo)
                  ? materialiCatalogo.length
                  : 0}
              </small>
            </div>

            {materialeCatalogoId ? (
              <button
                type="button"
                className="materiale-manuale-btn"
                onClick={() => {
                  handleSelectMaterialeCatalogo("");
                  setRicercaMaterialeCatalogo("");
                  setCatalogoMaterialiAperto(false);
                }}
              >
                Passa a manuale
              </button>
            ) : (
              <span className="materiale-manuale-badge">
                Inserimento manuale
              </span>
            )}
          </div>

          <div className="materiale-autocomplete">
            <input
              type="search"
              placeholder="Cerca codice o descrizione..."
              value={ricercaMaterialeCatalogo}
              autoComplete="off"
              onFocus={() =>
                setCatalogoMaterialiAperto(true)
              }
              onBlur={() =>
                setTimeout(
                  () => setCatalogoMaterialiAperto(false),
                  150
                )
              }
              onChange={(e) => {
                setRicercaMaterialeCatalogo(e.target.value);
                setCatalogoMaterialiAperto(true);
              }}
            />

            {catalogoMaterialiAperto && (
              <div
                className="materiale-autocomplete-list"
                role="listbox"
              >
                {loadingMaterialiCatalogo ? (
                  <div className="materiale-autocomplete-empty">
                    Caricamento catalogo...
                  </div>
                ) : materialiCatalogoFiltrati.length > 0 ? (
                  materialiCatalogoFiltrati.map((materiale) => (
                    <button
                      key={materiale.id}
                      type="button"
                      className={
                        Number(materialeCatalogoId) ===
                        Number(materiale.id)
                          ? "materiale-autocomplete-item selected"
                          : "materiale-autocomplete-item"
                      }
                      onMouseDown={(e) =>
                        e.preventDefault()
                      }
                      onClick={() => {
                        handleSelectMaterialeCatalogo(
                          materiale.id
                        );
                        setRicercaMaterialeCatalogo("");
                        setCatalogoMaterialiAperto(false);
                      }}
                    >
                      <span className="materiale-item-main">
                        <strong>
                          {materiale.codiceMateriale}
                        </strong>

                        <span>
                          {materiale.descrizioneMateriale}
                        </span>
                      </span>

                      <span className="materiale-item-meta">
                        <strong>
                          {Number(
                            materiale.prezzoSenzaIva || 0
                          ).toFixed(2)} €
                        </strong>

                        <small>
                          Q.tà {materiale.quantita ?? 0}
                        </small>
                      </span>
                    </button>
                  ))
                ) : (
                  <div className="materiale-autocomplete-empty">
                    Nessun materiale trovato
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        <div className="materiale-intervento-fields">
          <input
            type="text"
            placeholder="Codice materiale"
            value={codiceMateriale ?? ""}
            onChange={(e) =>
              setCodiceMateriale(e.target.value)
            }
          />

          <input
            type="text"
            placeholder="Descrizione"
            value={descrizioneMateriale ?? ""}
            onChange={(e) =>
              setDescrizioneMateriale(e.target.value)
            }
          />

          <input
            type="number"
            min="0.01"
            step="0.01"
            placeholder="Quantità"
            value={quantitaMateriale ?? ""}
            onChange={(e) =>
              setQuantitaMateriale(e.target.value)
            }
          />

          <input
            type="number"
            min="0"
            step="0.01"
            placeholder="Prezzo unitario"
            value={prezzoUnitario ?? ""}
            onChange={(e) =>
              setPrezzoUnitario(e.target.value)
            }
          />

          <input
            type="number"
            placeholder="Totale"
            value={totale ?? ""}
            disabled
          />
        </div>

        <button
          type="button"
          onClick={
            materialeDaModificare
              ? handleUpdateMateriale
              : handleAddMateriale
          }
          className="btn"
        >
          {materialeDaModificare
            ? "Aggiorna Materiale"
            : "Aggiungi Materiale"}
        </button>

        {Array.isArray(materiali) && materiali.length > 0 && (
          <table className="materiali-table">
            <thead>
              <tr>
                <th>Codice</th>
                <th>Descrizione</th>
                <th>Quantità</th>
                <th>Prezzo</th>
                <th>Totale</th>
                <th>Azioni</th>
              </tr>
            </thead>

            <tbody>
              {materiali.map((materiale) => (
                <tr key={materiale.id}>
                  <td>{materiale.codiceMateriale}</td>
                  <td>{materiale.descrizioneMateriale || "-"}</td>
                  <td>{materiale.quantitaMateriale}</td>
                  <td>
                    {Number(materiale.prezzoUnitario || 0).toFixed(2)} €
                  </td>
                  <td>
                    {(
                      Number(materiale.quantitaMateriale || 0) *
                      Number(materiale.prezzoUnitario || 0)
                    ).toFixed(2)} €
                  </td>
                  <td>
                    <button
                      type="button"
                      onClick={() =>
                        handleEditMateriale(materiale)
                      }
                      className="edit-btn"
                    >
                      Modifica
                    </button>

                    <button
                      type="button"
                      onClick={() =>
                        handleDeleteMateriale(materiale.id)
                      }
                      className="delete-btn"
                    >
                      Elimina
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <section className="intervento-card intervento-card--lavorazione">
          <div className="intervento-card-header">
            <div>
              <h4>Lavorazione</h4>
              <p>Attività eseguite e data principale dell'intervento</p>
            </div>
          </div>

          <div className="intervento-grid">
            
              <div className="intervento-field">
                <label>Data principale</label>
                <input
                  type="date"
                  value={data ?? ""}
                  onChange={(e) => setData(e.target.value || "")}
                />
              </div>
          </div>
        </section>

        <section className="intervento-card intervento-card--trasferta">
          <div className="intervento-card-header">
            <div>
              <h4>Trasferta</h4>
              <p>Percorrenza e dati di viaggio</p>
            </div>
          </div>


          {!isClassificazione && interventoId && (
            <div
              style={{
                marginBottom: 14,
                padding: 12,
                borderRadius: 10,
                background: "#f5f7fa",
                border: "1px solid #dde3ea",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 10,
                  flexWrap: "wrap",
                  marginBottom: 10,
                }}
              >
                <div>
                  <strong>Flotta automatica</strong>
                  <div
                    style={{
                      fontSize: 12,
                      opacity: 0.72,
                      marginTop: 2,
                    }}
                  >
                    Viaggi collegati a questo intervento
                  </div>
                </div>

                <span
                  style={{
                    padding: "4px 8px",
                    borderRadius: 999,
                    background: "#e8eef7",
                    fontSize: 12,
                    fontWeight: 700,
                  }}
                >
                  {trasfertaAutoV2C?.summary?.status ||
                    (trasfertaAutoLoadingV2C
                      ? "caricamento"
                      : "non disponibile")}
                </span>
              </div>

              {trasfertaAutoLoadingV2C ? (
                <div style={{ fontSize: 13 }}>
                  Caricamento dati Flotta…
                </div>
              ) : trasfertaAutoErrorV2C ? (
                <div style={{ fontSize: 13 }}>
                  {trasfertaAutoErrorV2C}
                </div>
              ) : (
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      "repeat(auto-fit, minmax(130px, 1fr))",
                    gap: 8,
                  }}
                >
                  {[
                    [
                      "Viaggi",
                      trasfertaAutoV2C?.summary?.completedTrips ?? 0,
                    ],
                    [
                      "Km automatici",
                      trasfertaAutoV2C?.summary?.totalDistanceKm == null
                        ? "—"
                        : `${formatFlottaNumberV2C(
                            trasfertaAutoV2C.summary.totalDistanceKm,
                            2
                          )} km`,
                    ],
                    [
                      "MAF catturato",
                      `${trasfertaAutoV2C?.summary?.capturedMafTrips ?? 0}/${trasfertaAutoV2C?.summary?.completedTrips ?? 0}`,
                    ],
                    [
                      "Litri stimati",
                      trasfertaAutoV2C?.summary?.estimatedLiters == null
                        ? "—"
                        : `${formatFlottaNumberV2C(
                            trasfertaAutoV2C.summary.estimatedLiters,
                            3
                          )} L`,
                    ],
                    [
                      "Costo carburante",
                      trasfertaAutoV2C?.summary?.fuelCostEuro == null
                        ? "—"
                        : `${formatFlottaNumberV2C(
                            trasfertaAutoV2C.summary.fuelCostEuro,
                            2
                          )} €`,
                    ],
                  ].map(([label, value]) => (
                    <div
                      key={label}
                      style={{
                        padding: 9,
                        borderRadius: 8,
                        background: "#fff",
                      }}
                    >
                      <div
                        style={{
                          fontSize: 11,
                          opacity: 0.68,
                        }}
                      >
                        {label}
                      </div>
                      <strong
                        style={{
                          display: "block",
                          marginTop: 3,
                        }}
                      >
                        {value}
                      </strong>
                    </div>
                  ))}
                </div>
              )}

              <div
                style={{
                  marginTop: 9,
                  fontSize: 11,
                  opacity: 0.68,
                }}
              >
                Dato automatico in sola lettura.
                I campi manuali “Km percorsi”,
                “Tempo di percorrenza” e
                “Trasferta” qui sotto non vengono
                sovrascritti.
              </div>
            </div>
          )}

          <div className="intervento-grid intervento-grid--three">
            <div className="intervento-field">
              <label>Km percorsi</label>
              <input
                type="number"
                value={kmPercorsi ?? ""}
                onChange={(e) => setKmPercorsi(e.target.value || "")}
              />
            </div>

            <div className="intervento-field">
              <label>Tempo di percorrenza</label>
              <input
                type="text"
                value={tempoPercorrenza ?? ""}
                onChange={(e) => setTempoPercorrenza(e.target.value || "")}
              />
            </div>

            <div className="intervento-field">
              <label>Trasferta</label>
              <input
                type="text"
                value={trasferta ?? ""}
                onChange={(e) => setTrasferta(e.target.value || "")}
              />
            </div>
          </div>
        
          {/* BETALUMINA_INTERVENTI_TRASFERTA_DETTAGLIO_R1 */}
          <div style={{ marginTop: 14, padding: 14, border: "1px solid #d6dee6", borderRadius: 10, background: "#f8fafc" }}>
            <h4 style={{ margin: "0 0 6px 0" }}>Costi trasferta e accessori</h4>
            <small style={{ display: "block", marginBottom: 12, color: "#66788a" }}>Compila solo le voci necessarie. I valori vuoti o pari a zero non saranno stampati nel PDF.</small>
            {[
              ["tariffaKm", "Tariffa €/km"], ["oreViaggio", "Ore di viaggio"], ["tariffaViaggio", "Tariffa viaggio €/h"],
              ["pedaggi", "Pedaggi (€)"], ["parcheggi", "Parcheggi (€)"], ["spedizioni", "Spedizioni / trasporto materiali (€)"],
              ["noleggi", "Noleggi / mezzi speciali (€)"], ["smaltimento", "Smaltimento (€)"], ["consumo", "Materiale di consumo (€)"],
            ].map(([field, label]) => (
              <div key={field} style={{ display: "grid", gridTemplateColumns: "minmax(190px, 1fr) 160px", gap: 10, alignItems: "center", marginBottom: 8 }}>
                <label style={{ margin: 0 }}>{label}</label>
                <input type="number" min="0" step="0.01" value={costiTrasfertaDettaglio?.[field] ?? ""} onChange={(e) => setCostiTrasfertaDettaglio((prev) => ({ ...(prev || {}), [field]: e.target.value }))} />
              </div>
            ))}
            <div style={{ display: "grid", gridTemplateColumns: "minmax(190px, 1fr) 160px", gap: 10, alignItems: "center" }}>
              <input type="text" placeholder="Descrizione altro costo" value={costiTrasfertaDettaglio?.altroDescrizione ?? ""} onChange={(e) => setCostiTrasfertaDettaglio((prev) => ({ ...(prev || {}), altroDescrizione: e.target.value }))} />
              <input type="number" min="0" step="0.01" placeholder="Importo €" value={costiTrasfertaDettaglio?.altroImporto ?? ""} onChange={(e) => setCostiTrasfertaDettaglio((prev) => ({ ...(prev || {}), altroImporto: e.target.value }))} />
            </div>
          </div>
</section>

        {/* Stato e pausa */}
        {!isClassificazione && (
          <section className="intervento-card intervento-card--stato">
            <div className="intervento-card-header">
              <div>
                <h4>Stato e pausa</h4>
                <p>Avanzamento dell'intervento e tempo di pausa</p>
              </div>
            </div>

            <div
              className="stato-buttons"
              role="group"
              aria-label="Stato intervento"
            >
              {[
                { value: "Da fare", label: "Da fare" },
                { value: "In corso", label: "In corso" },
                { value: "Completato", label: "Chiuso" },
              ].map((opt) => (
                <button
                  key={opt.value}
                  type="button"
                  className={`stato-btn ${stato === opt.value ? "active" : ""}`}
                  onClick={() => handleStatoButtonClick(opt.value)}
                  disabled={lavoroBusy}
                  aria-pressed={stato === opt.value}
                >
                  {opt.label}
                </button>
              ))}

              <button
                type="button"
                className={`pause-btn ${isPaused ? "active" : ""}`}
                onClick={handleTogglePausa}
            disabled={pausaBusy}
                aria-pressed={isPaused}
                title={isPaused ? "Riprendi lavoro" : "Metti in pausa"}
              >
                {isPaused ? "Riprendi" : "Pausa"}
              </button>

              <button
                type="button"
                className={`pause-btn ${lavoroAttivo ? "active" : ""}`}
                onClick={fineLavoroOperativo}
                disabled={lavoroBusy || !lavoroAttivo}
                title={
                  lavoroAttivo
                    ? "Registra automaticamente l'ora di fine lavoro"
                    : "Avvia prima il lavoro con In corso"
                }
              >
                Fine lavoro
              </button>
            </div>

            <div className="pause-row">
              <span className={`pause-badge ${isPaused ? "on" : ""}`}>
                {isPaused ? "In pausa" : "Operativo"}
              </span>
              <span className="pause-info">
                Pausa oggi: {displayedPausaClock}
              </span>
            </div>

            <div className="pause-manual-row">
              <div className="intervento-field pausa-manuale-field">
                <label>Pausa complessiva registrata</label>
                <div className="pausa-manuale-input">
                  <input
                    type="number"
                    value={Number(pausaTotaleMin) || 0}
                    readOnly
                    aria-readonly="true"
                  />
                  <span>minuti</span>
                </div>
                <small>
                  Le correzioni manuali si effettuano nella colonna
                  "Pausa min" delle Giornate intervento.
                </small>
              </div>
            </div>
          </section>
        )}

        {!isClassificazione && (
          <GiornateIntervento
            interventoId={interventoId}
            tecnicoDefault={String(tecnico || "").trim() || "Carrino"}
            dataDefault={data}
          />
        )}


        {interventoId && (
          <section className="intervento-card firma-cliente-v2-card">
            <div className="intervento-card-header">
              <div>
                <h4>Firma cliente</h4>
                <p>Firma di presa visione del rapportino di intervento</p>
              </div>
            </div>

            <div className="firma-cliente-v2-status">
              <span className={`firma-cliente-v2-badge ${firmaClientePresenteV2 ? "is-signed" : ""}`}>
                {firmaClientePresenteV2
                  ? `Firmato${firmaClienteNomeV2 ? ` da ${firmaClienteNomeV2}` : ""}`
                  : "Da firmare"}
              </span>

              <div className="firma-cliente-v2-actions">
                <button
                  type="button"
                  className="firma-cliente-v2-primary"
                  onClick={enterFirmaClienteLandscapeV2}
                  disabled={firmaClienteSavingV2}
                >
                  {firmaClientePresenteV2 ? "Modifica firma" : "Firma cliente"}
                </button>

                {firmaClientePresenteV2 && (
                  <button
                    type="button"
                    className="firma-cliente-v2-remove"
                    onClick={removeFirmaClienteV2}
                    disabled={firmaClienteSavingV2}
                  >
                    Rimuovi firma
                  </button>
                )}
              </div>
            </div>

            {firmaClienteMsgV2 && !firmaClienteOpenV2 && (
              <div className="firma-cliente-v2-msg">{firmaClienteMsgV2}</div>
            )}
          </section>
        )}

        <div className={`firma-cliente-v2-overlay ${firmaClienteOpenV2 ? "is-open" : ""}`}>
          <div
            className="firma-cliente-v2-dialog"
            role="dialog"
            aria-modal="true"
            aria-label="Firma cliente"
          >
            <div className="firma-cliente-v2-head">
              <div>
                <h3>Firma cliente</h3>
                <p>Firma con il dito nel riquadro e inserisci il nome.</p>
              </div>
              <button
                type="button"
                className="firma-cliente-v2-close"
                onClick={exitFirmaClienteLandscapeV2}
                disabled={firmaClienteSavingV2}
                aria-label="Chiudi"
              >
                Ã—
              </button>
            </div>

            <div className="firma-cliente-v2-rotate">
              Schermata firma: usa il telefono in orizzontale.
            </div>

            <label className="firma-cliente-v2-name-label" htmlFor="firma-cliente-v2-nome">
              Nome e cognome del firmatario
            </label>
            <input
              id="firma-cliente-v2-nome"
              type="text"
              maxLength={120}
              autoComplete="name"
              value={firmaClienteNomeV2}
              onChange={(event) => setFirmaClienteNomeV2(event.target.value)}
              placeholder="Es. Mario Rossi"
              disabled={firmaClienteSavingV2}
            />

            <div className="firma-cliente-v2-canvas-wrap">
              <canvas
                ref={firmaClienteCanvasRefV2}
                className="firma-cliente-v2-canvas"
                onPointerDown={firmaClientePointerDownV2}
                onPointerMove={firmaClientePointerMoveV2}
                onPointerUp={firmaClientePointerUpV2}
                onPointerCancel={firmaClientePointerUpV2}
                aria-label="Area firma cliente"
              />
            </div>

            <div className="firma-cliente-v2-toolbar">
              <button
                type="button"
                className="firma-cliente-v2-secondary"
                onClick={clearFirmaClienteV2}
                disabled={firmaClienteSavingV2}
              >
                Cancella firma
              </button>

              <div className="firma-cliente-v2-toolbar-right">
                <button
                  type="button"
                  className="firma-cliente-v2-secondary"
                  onClick={exitFirmaClienteLandscapeV2}
                  disabled={firmaClienteSavingV2}
                >
                  Annulla
                </button>

                <button
                  type="button"
                  className="firma-cliente-v2-primary"
                  onClick={saveFirmaClienteV2}
                  disabled={firmaClienteSavingV2}
                >
                  {firmaClienteSavingV2 ? "Salvataggio..." : "Salva firma"}
                </button>
              </div>
            </div>

            {firmaClienteMsgV2 && firmaClienteOpenV2 && (
              <div className="firma-cliente-v2-dialog-msg" role="status">
                {firmaClienteMsgV2}
              </div>
            )}
          </div>
        </div>

        <section className="intervento-card intervento-card--amministrazione">
          <div className="intervento-card-header">
            <div>
              <h4>Amministrazione</h4>
              <p>Dati fiscali e stato del pagamento</p>
            </div>
          </div>

          <div className="intervento-grid intervento-grid--three">
            <div className="intervento-field">
              <label>P.IVA</label>
              <input
                type="text"
                value={piva ?? ""}
                onChange={(e) => setPiva(e.target.value || "")}
              />
            </div>

            <div className="intervento-field">
              <label>Metodo di pagamento</label>
              <input
                type="text"
                value={metodoPagamento ?? ""}
                onChange={(e) => setMetodoPagamento(e.target.value || "")}
              />
            </div>

            <div className="intervento-field intervento-field--pagato">
              <label>Pagamento</label>
              <label className="intervento-check-row">
                <input
                  type="checkbox"
                  checked={pagato ?? false}
                  onChange={(e) => setPagato(e.target.checked)}
                />
                <span>{pagato ? "Pagato" : "Non pagato"}</span>
              </label>
            </div>
          </div>
        </section>

    </div>
  );
};

export default React.memo(InterventoForm);


